<div class="big-card-page" data-test="cookies-required">
  <div class="big-card-page__card">
    <div class="big-card-page__icon">
      <img src="/assets/images/icons/expired-link.svg" alt="" />
    </div>
    <div
      class="big-card-page__title"
      [innerHTML]="'COOKIES_REQUIRED.TITLE' | translate"
      data-test="cookies-required-title"
    ></div>
    <div
      class="big-card-page__desc"
      [innerHTML]="'COOKIES_REQUIRED.DESCRIPTION' | translate: { origin: authOrigin }"
      data-test="cookies-required-description"
    ></div>
    <div class="big-card-page__extra-action">
      <a
        [routerLink]="['/login']"
        data-test="cookies-required-back-to-connection"
        >{{ 'COOKIES_REQUIRED.BACK_TO_CONNECTION' | translate }}</a
      >
    </div>
  </div>
</div>
